import React from "react";

// import { useNavigate } from "react-router-dom";

import dogHeart from "../../assets/images/catbook/cat-heart-p2.png";
import SuccessStyle from "../../assets/images/success-style.png";
import { useNavigate } from "react-router-dom";
import TopLogoCat from "../../components/layout/TopLogoCat";
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";
import PrimaryButton from "../../components/button/PrimaryButton";

export default function DogAddCatSuccess() {
    const navigate = useNavigate();
    return (
        <>
            <TopLogoCat />
            <div
                style={{
                    minHeight: "calc(100vh - 60px)",
                    padding: "20px",
                    background: "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",
                }}
            >
                <img
                    src={SuccessStyle}
                    alt="logo"
                    style={{ width: "70%", float: "right" }}
                    className="mt-[-20px] mr-[-20px]"
                />
                <div className="mt-[40px] w-full" style={{
                    position: "fixed",
                    left: "50%",
                    transform: "translate(-50%, 0)"
                }}>
                    <div className="text-white text-center  text-[36px] mt-[62px]">
                        เพิ่มน้องแมวในสมุดพกแล้ว
                    </div>
                    <img
                        className="w-[157px] mt-[37px] mb-[70px] mx-auto"
                        src={dogHeart}
                        alt=""
                    />
                    <div className="text-center mt-[50px]">
                        {/*btn member*/}
                        <div className="my-4">
                            <PrimaryButton
                                variant="contained"
                                className="w-[70%] !bg-[#082e683d]"
                                onClick={() => {
                                    navigate("/dogbook");
                                }}
                            >
                                กลับไปที่สมุดพกสัตว์เลี้ยง
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
